<footer
  class="lg:container relative flex flex-col justify-center align-middle items-center mt-7 mb-20 gap-3 py-3 rounded-[36px] bg-white dark:bg-surface-dark transition-colors"
>
  <span class="text-sm text-center text-dark dark:text-white"> © Far East Consortium 2026 </span>
  <span
    class="md:absolute md:right-7 text-black dark:text-grey text-base font-extralight leading-6 tracking-[0.12px]"
  >
    build: v{{ buildVersion() || '' }}
  </span>
</footer>
